import * as yup from "yup";
import {endOfToday} from "date-fns";

const paymentValidationSchema = yup.object().shape({
    date: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .min('1900', "Data non valida, deve essere maggiore di 01/01/1900")
        .max(endOfToday(), "Data non valida, deve essere minore rispetto ad oggi")
        .required('Campo obbligatorio'),

    paymentType: yup
        .string()
        .typeError('Campo non valido')
        .required('Campo obbligatorio'),

    reasonOfPayment: yup
        .string()
        .typeError('Campo non valido')
        .required('Campo obbligatorio'),

    amount: yup
        .number()
        .positive('Deve essere un numero positivo')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
});

export default paymentValidationSchema;